<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancelClick()">
    {{ data.cancelButtonText }}
  </button>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    {{ data.confirmButtonText }}
  </button>
</mat-dialog-actions>
